import {
  COLOR_MODE_COOKIE_NAME,
  ColorMode,
  DEFAULT_COLOR_MODE,
} from '@/helpers';
import { getCookie, removeCookie, setCookie } from '@onbeam/utils';
import { create } from 'zustand';
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware';

const cookiesStorage: StateStorage = {
  getItem: getCookie,
  setItem: setCookie,
  removeItem: removeCookie,
};

type Store = {
  colorMode: ColorMode;
  setColorMode: (newMode: ColorMode) => void;
};

export const useColorModeStore = create<Store>()(
  persist(
    (set, get) => ({
      colorMode: DEFAULT_COLOR_MODE,
      setColorMode: (newMode: ColorMode) => {
        const { colorMode: currentMode } = get();
        set({ colorMode: newMode });
        document.body.classList.remove(currentMode);
        document.body.classList.add(newMode);
      },
    }),
    {
      name: COLOR_MODE_COOKIE_NAME,
      storage: createJSONStorage(() => cookiesStorage),
    },
  ),
);
